import styled from '@emotion/styled'
import * as React from 'react'

import Text from './typography/Text'

const StyledText = styled(Text)`
    a,
    a:visited,
    a:hover {
        color: inherit;
        text-decoration: underline;
    }

    a:hover {
        text-decoration: none;
    }
`

const Note = ({
    className,
    children,
}: {
    className?: string
    children: React.ReactNode
}) => (
    <StyledText variant="secondary" color="grey" className={className}>
        {children}
    </StyledText>
)

export default Note
